<template>
  <!-- 优惠券选择弹窗 -->
  <CouponList
    :coupons="allCoupons"
    :couponAfterMoney="couponAfterMoney"
    @onSelectedCoupons="onSelectedCoupons"
  />
</template>
<script>
  // 优惠券-新版-PC
  import couponMixins from './couponMixins'
  import CouponList from './CouponList/index_pc'

  export default {
    mixins: [couponMixins],
    components: {
      CouponList,
    },
    data() {
      return {}
    },
  }
</script>
